module.exports = __webpack_public_path__ + "de8b4e95945454b63886860c0f2f93ee.svg";